import React, { useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import EstoreNavbar from "./components/EstoreNavbar";
import EstoreSchoolProcurementHub from "./components/EstoreSchoolProcurementHub";
import EstoreHero from "./components/EstoreHero";
import EstoreCategories from "./components/EstoreCategories";
import EstoreFeatured from "./components/EstoreFeatured";
import EstorePromo from "./components/EstorePromo";
import EstoreFooter from "./components/EstoreFooter";
import { brand, searchCatalog } from "./data/estoreContent";
import { estoreProductUrl, estoreShopUrl } from "./data/estorePaths";

function EstoreHome() {
  const navigate = useNavigate();
  const [navFixed, setNavFixed] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    const onScroll = () => setNavFixed(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    if (query.trim().length > 0) {
      const q = query.toLowerCase();
      const filtered = searchCatalog
        .filter((p) => p.title.toLowerCase().includes(q) || p.category.toLowerCase().includes(q))
        .slice(0, 6);
      setSearchSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setSearchSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSearchSubmit = () => {
    if (!searchQuery.trim()) return;
    navigate(estoreShopUrl(searchQuery.trim()));
    setShowSuggestions(false);
  };

  const handleSuggestionClick = (product) => {
    navigate(estoreProductUrl(product.id));
    setShowSuggestions(false);
    setSearchQuery("");
  };

  const handleClickAwaySuggestions = () => setShowSuggestions(false);

  const bg = useMemo(
    () =>
      `radial-gradient(900px 500px at 12% 0%, rgba(99,102,241,0.12) 0%, transparent 55%),
       radial-gradient(800px 480px at 92% 8%, rgba(14,165,233,0.10) 0%, transparent 50%),
       linear-gradient(180deg, ${brand.bg} 0%, #FFFFFF 100%)`,
    []
  );

  return (
    <Box sx={{ mt: 7, minHeight: "100vh", background: bg, color: brand.text }}>
      <EstoreNavbar
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        onSearchSubmit={handleSearchSubmit}
        showSuggestions={showSuggestions}
        searchSuggestions={searchSuggestions}
        onSuggestionClick={handleSuggestionClick}
        onClickAwaySuggestions={handleClickAwaySuggestions}
      />
      <EstoreSchoolProcurementHub />
      <EstoreHero stickyOffset={navFixed} />
      <EstoreCategories />
      <EstoreFeatured />
      <EstorePromo />
      <EstoreFooter />
    </Box>
  );
}

export default EstoreHome;
